import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full bg-espresso py-10 text-cream" aria-label="Key numbers" data-id="element-217" data-mp="1tarjq9bipqkw">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-8 px-5 md:grid-cols-4" data-id="element-218" data-mp="1obeyft0aorkf">
        {stats.map(stat => <div key={stat.label} data-id="element-219" data-mp="1jctx1q9b41ue">
            <p className="font-display text-3xl font-semibold leading-none text-goldlight sm:text-4xl" data-id="element-220" data-mp="1jbiutuvif25e">
              {stat.value}
            </p>
            <p className="mt-3 font-sans text-sm leading-snug text-cream/70" data-id="element-221" data-mp="19misq2lpnqmz">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}